var _rect, _g, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2176_2985)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2176_2985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.498 32.0001H27.502C26.8404 33.5824 25.5823 34.8405 24 35.5021C22.4177 34.8405 21.1596 33.5824 20.498 32.0001ZM30 26.8051L32 29.0731V31.0001H16V29.0731L18 26.8051V21.0001C18 17.5171 20.504 14.5531 24 13.4551C27.496 14.5531 30 17.5171 30 21.0001V26.8051ZM24 23.0001C24.5304 23.0001 25.0391 22.7894 25.4142 22.4143C25.7893 22.0392 26 21.5305 26 21.0001C26 20.4696 25.7893 19.9609 25.4142 19.5859C25.0391 19.2108 24.5304 19.0001 24 19.0001C23.4696 19.0001 22.9609 19.2108 22.5858 19.5859C22.2107 19.9609 22 20.4696 22 21.0001C22 21.5305 22.2107 22.0392 22.5858 22.4143C22.9609 22.7894 23.4696 23.0001 24 23.0001Z",
    fill: "#6E51E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.498 32.0001H27.502C26.8404 33.5824 25.5823 34.8405 24 35.5021C22.4177 34.8405 21.1596 33.5824 20.498 32.0001ZM30 26.8051L32 29.0731V31.0001H16V29.0731L18 26.8051V21.0001C18 17.5171 20.504 14.5531 24 13.4551C27.496 14.5531 30 17.5171 30 21.0001V26.8051ZM24 23.0001C24.5304 23.0001 25.0391 22.7894 25.4142 22.4143C25.7893 22.0392 26 21.5305 26 21.0001C26 20.4696 25.7893 19.9609 25.4142 19.5859C25.0391 19.2108 24.5304 19.0001 24 19.0001C23.4696 19.0001 22.9609 19.2108 22.5858 19.5859C22.2107 19.9609 22 20.4696 22 21.0001C22 21.5305 22.2107 22.0392 22.5858 22.4143C22.9609 22.7894 23.4696 23.0001 24 23.0001Z",
    fill: "url(#paint0_linear_2176_2985)",
    fillOpacity: 0.24
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "#F4F5FA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2176_2985",
    x1: 24,
    y1: 13.4551,
    x2: 24,
    y2: 35.5021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2176_2985"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2176_2985"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/Icon2.5504a1042766ac3b093d66879830ebfd.svg";
export { ForwardRef as ReactComponent };